// extracted by mini-css-extract-plugin
export default {"my-opening-hours":"OpeningHours_my-opening-hours__r5GT7","active-day":"OpeningHours_active-day__dG18Q","custom-overlay":"OpeningHours_custom-overlay__TvZTT"};